import { createContext } from "react";

const StepContext = createContext();

export default StepContext;